import { Controller } from "@hotwired/stimulus"

import { formatISO } from "@/helpers/date_format"

const SELECTED_RANGE_CLASS = "in-selected-range"
const FIRST_IN_SELECTED_RANGE_CLASS = "first-in-selected-range"
const LAST_IN_SELECTED_RANGE_CLASS = "last-in-selected-range"

export default class extends Controller {
  static targets = ["dateRadio"]
  declare readonly dateRadioTargets: HTMLInputElement[]

  static values = { numberOfNights: Number }
  declare numberOfNightsValue: number

  connect(): void {
    const selectedDateRadio = this.dateRadioTargets.find((radio) => radio.checked)

    if (selectedDateRadio) {
      this.highlightDateRange(selectedDateRadio)
    }
  }

  dateSelected(event: Event): void {
    this.highlightDateRange(event.currentTarget as HTMLInputElement)
  }

  private highlightDateRange(target: HTMLInputElement): void {
    if (this.numberOfNightsValue === 0) {
      return
    }

    const targetDate = new Date(target.value)
    const startDate = new Date(targetDate)
    const endDate = new Date(targetDate.setDate(targetDate.getDate() + this.numberOfNightsValue))
    const endDateRadio = this.dateRadioTargets.find((radio) => radio.value === formatISO(endDate))

    this.dateRadioTargets.forEach((radio) => {
      const date = new Date(radio.value)

      radio.className = ""

      if (radio === target) {
        radio.classList.add(FIRST_IN_SELECTED_RANGE_CLASS)
      } else if (radio.value === endDateRadio?.value) {
        radio.classList.add(LAST_IN_SELECTED_RANGE_CLASS)
      } else if (date > startDate && date < endDate) {
        radio.classList.add(SELECTED_RANGE_CLASS)
      }
    })
  }
}
